<template>
  <div>
    <div class="examination_box">
      <div>
        <el-tabs
          class="tabs"
          :stretch="true"
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane label="试卷详情" name="first"></el-tab-pane>
          <el-tab-pane label="试卷分析" name="second"></el-tab-pane>
        </el-tabs>
        <div class="xian"></div>
        <div v-show="activeName == 'second'" :style="style_h">
          <div v-show="show">
            <div class="box_left">
              <div>
                <div class="title">知识点分析</div>
                <!-- <div class="box_text" v-if="tableData.length == 0">暂无数据</div> -->
                <div class="box_con" id="main"></div>
              </div>
              <div class="table_right">
                <el-table
                  :header-cell-style="{
                    'text-align': 'center',
                    height: '50px',
                    background: '#2E9ADB',
                    color: '#FFFFFF',
                  }"
                  :cell-style="{
                    'text-align': 'center',
                    height: '50px',
                    background: '#fffefd',
                  }"
                  :data="tableData"
                  border
                >
                  <el-table-column prop="kpName" label="知识点" width="120">
                  </el-table-column>
                  <el-table-column prop="answerNum" label="答题数" width="120">
                  </el-table-column>
                  <el-table-column prop="currentNum" label="正确数" width="120">
                  </el-table-column>
                  <el-table-column
                    prop="currentRate"
                    label="正确率"
                    width="120"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.currentRate }}%</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div>
              <div class="box_bottom">
                <div class="title">资源推荐</div>
              </div>
              <div class="box_bottom_list">
                <div
                  class="ibox"
                  v-for="(item, index) in hotList"
                  :key="index"
                  @click="toDetail1(item.goodsId, item.goodsType)"
                >
                  <el-image class="img" :src="item.cover">
                    <div slot="error" class="image-slot">
                      <img class="img" src="@/assets/images/default_img.jpg" />
                    </div>
                  </el-image>
                  <div class="title">
                    <span v-if="item.sourceFile">{{ item.sourceFile }}</span
                    >{{ item.goodsTitle }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="!show" class="box_image">
            <img src="@/assets/images/none_img.png" />
          </div>
        </div>
        <div
          v-if="activeName == 'first'"
          style="height: 950px; width: 1450px; margin: 0 auto"
        >
          <iframe
            :src="src"
            frameborder="0"
            class="iframe"
            id="iframe"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { testURL } from "@/utils/config.js";
import { getStatisKpInfo } from "@/api/answer/answer";
import { paperGetToken, goodBookList } from "@/api/index/index";
export default {
  data() {
    return {
      activeName: "second",
      goodsId: "",
      tableData: [],
      indicator: [],
      currentNum: [],
      src: "",
      hotList: [],
      show: true,
      style_h: "950px",
    };
  },
  components: {},
  watch: {
    //监听
    $route(to, from) {},
  },
  created() {
    this.goodsId = this.$route.query.goodsId;
    this.getHotRecommended();
    this.getStatisKpInfo();
    this.src =
      testURL +
      "/answer-record?paperId=" +
      this.$route.query.paperId +
      "&ansRecordId=" +
      this.$route.query.testPaperId;
  },
  mounted() {},
  methods: {
    num(e) {
      let num = e.split(".")[0];
      return num;
    },
    //推荐商品
    getHotRecommended() {
      goodBookList({ pageNum: 1, pageSize: 6 })
        .then((res) => {
          let data = res.data || [],
            list = [];
          data.forEach((item, index) => {
            if (index <= 5) {
              let {
                bookName: goodsTitle,
                sourceFile,
                cover,
                bookId: goodsId,
              } = item;
              list.push({ goodsTitle, cover, sourceFile, goodsId });
            }
          });
          this.hotList = list;
        })
        .catch((err) => (this.hotList = []));
    },
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      };
    },
    //评价
    getStatisKpInfo() {
      paperGetToken().then((res) => {
        let data = {
          aprId: this.$route.query.testPaperId,
          token: res.data,
        };
        getStatisKpInfo(data).then((res) => {
          if (res.code == 200) {
            this.style_h = "950px";
            this.show = true;
            this.tableData = res.data;
            this.tableData = this.tableData.sort(this.compare("currentRate"));
            if (this.tableData.length != 0) {
              //答题数
              let indicator = [];
              indicator = this.tableData.map((item) => {
                item.max = item.answerNum;
                item.name = item.kpName;
                return item;
              });
              //正确率
              let currentNum = [];
              this.tableData.forEach((item) => {
                currentNum.push(item.currentNum);
              });
              this.currentNum = currentNum;
              this.indicator = indicator;
              this.drawChart();
            } else {
              this.style_h = " 600px";
              this.show = false;
            }
          }
        });
      });
    },
    drawChart() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      var that = this;
      let myChart = echarts.init(document.getElementById("main"));
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "axis",
        },
        radar: {
          indicator: this.indicator,
          radius: 190,
        },
        series: [
          {
            type: "radar",
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                var res = "<div><p>" + params.data.name + "</p></div>";
                for (var i = 0; i < params.data.value.length; i++) {
                  res +=
                    "<p>" +
                    that.indicator[i].name +
                    ":" +
                    that.indicator[i].currentRate +
                    "%" +
                    "</p>";
                }
                return res;
              },
            },
            center: ["50%", "50%"],
            data: [
              {
                value: this.currentNum,
                name: "知识点正确率",
              },
            ],
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    handleClick() {},
    //跳转到对应商品
    toDetail1(id, type) {
      this.$router.push({
        path: "/bookstore/bookstoreDetail",
        query: { goodsId: id, goodsType: type },
      });
    },
  },
};
</script>
<style scoped lang='scss'>
.examination_box {
  width: 1400px;
  background: #fffefd;
  margin: 0 auto;
}

.tabs {
  width: 240px;
  margin: 0 auto;
}

.box_left {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 25px;
  .title {
    padding: 0px 10px;
    border-left: 5px solid #2e9adb;
  }
  .box_con {
    width: 600px;
    height: 550px;
    margin-left: 50px;
  }
}
.table_right {
  margin-right: 50px;
}
.box_bottom {
  padding: 25px;
  .title {
    padding: 0px 10px;
    border-left: 5px solid #2e9adb;
  }
}

.box_bottom_list {
  display: flex;
  flex-direction: row;
  align-content: center;
  padding: 0 15px;
  .ibox {
    padding: 10px 20px;
    .img {
      width: 170px;
      height: 170px;
    }
    .title {
      margin-top: 10px;
      width: 170px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 20px;
      span {
        padding: 0 5px;
        height: 24px;
        background: #f9fdff;
        margin-right: 7px;
        border: 1px solid #0081ce;
        border-radius: 6px;
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #0081ce;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}
.xian {
  width: 1400px;
  height: 2px;
  background: #f2f2f2;
  margin-top: -16px;
}
.box_text {
  width: 600px;
  height: 550px;
  text-align: center;
  line-height: 550px;
}
.iframe {
  width: 100%;
  height: 100%;
}
.box_image {
  width: 300px;
  height: 300px;
  margin: 250px auto;
}
</style>